module.exports = __webpack_public_path__ + "static/img/login-adv.3c02850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-adv.png
// module id = 6wCc
// module chunks = 1